/* eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  object,
  Formik,
  withRouter,
  invokeEventHandler,
  callOnOpenPreSubmit,
  callOnOpenService,
  handleModalHide,
  parentWindow,
  dataCopyObj,
  showMessage,
  switchToTab,
  useAppContext,
  useHistory,
  useLocation,
  useRouteMatch,
  Modal,
  _kaledo,
  initForm,
  GroupBoxWidget,
  CommandContainerWidget,
  ButtonWidget,
} from "../../shared/WindowImports";

import "./Delivery.scss";

// START_USER_CODE-USER_IMPORTS
import ContractManagement_header from "../../Header/Header";
import StripPic from "../../../../assets/img/PinStrip.png";
// END_USER_CODE-USER_IMPORTS
function WarehouseReceipts_Delivery(props) {
  const contextType = useAppContext();
  const screenRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  // START_USER_CODE-USER_PROPERTIES

  // END_USER_CODE-USER_PROPERTIES

  let states = {
    Label: "Delivery",
    windowName: "Delivery",
    template: "Standard Screen",
    Cols: "3",
    ColsForMobile: "3",
    ColsForTabLandscape: "3",
    ColsForTabPotrait: "3",
    is12Column: false,
    isResponsiveLayout: false,
    Height: "",
    Left: "",
    Top: "",
    Width: "",
    i18Key: "WarehouseReceipts.Delivery",
    // START_USER_CODE-USER_Delivery_PROPERTIES
    headerData: {
      scrName: "Delivery In/Out Menu",
      scrCode: "PN1180",
    },
    // END_USER_CODE-USER_Delivery_PROPERTIES
    btnClose: {
      name: "btnClose",
      type: "ButtonWidget",
      parent: "cmmndCntnrClose",
      Label: "Close",
      CharWidth: "13",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnClose_PROPERTIES

      // END_USER_CODE-USER_btnClose_PROPERTIES
    },
    btnDelAgreeProfile: {
      name: "btnDelAgreeProfile",
      type: "ButtonWidget",
      parent: "grpbxDeliveryMenu",
      Label: "Delivery Agree Profile",
      CharWidth: "45",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnDelAgreeProfile_PROPERTIES

      // END_USER_CODE-USER_btnDelAgreeProfile_PROPERTIES
    },
    btnDelSettleProfile: {
      name: "btnDelSettleProfile",
      type: "ButtonWidget",
      parent: "grpbxDeliveryMenu",
      Label: "Delivery Settle Profile",
      CharWidth: "46",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnDelSettleProfile_PROPERTIES

      // END_USER_CODE-USER_btnDelSettleProfile_PROPERTIES
    },
    grpbxDeliveryMenu: {
      name: "grpbxDeliveryMenu",
      type: "GroupBoxWidget",
      parent: "Delivery",
      Height: "",
      Width: "",
      ColsForMobile: "2",
      ColsForTabLandscape: "2",
      HasLabel: false,
      Cols: "2",
      ColsForTabPotrait: "2",
      ColsForLargeDesktop: "2",
      // START_USER_CODE-USER_grpbxDeliveryMenu_PROPERTIES

      // END_USER_CODE-USER_grpbxDeliveryMenu_PROPERTIES
    },
    cmmndCntnrClose: {
      name: "cmmndCntnrClose",
      type: "CommandContainerWidget",
      parent: "Delivery",
      Height: "",
      Width: "",
      HasLabel: false,
      // START_USER_CODE-USER_cmmndCntnrClose_PROPERTIES

      // END_USER_CODE-USER_cmmndCntnrClose_PROPERTIES
    },
    _dataCopy: {
      FORWARD: {
        "WarehouseReceipts#DelvAgreeSearch":{},
        "WarehouseReceipts#DelvSettleSearch":{}
      },
      REVERSE: {
        "WarehouseReceipts#DelvAgreeSearch":{},
        "WarehouseReceipts#DelvSettleSearch":{}
      },
    },
  };
  let _buttonServices = {};
  let _buttonNavigation = {
    btnDelAgreeProfile:{
      DEFAULT:["WarehouseReceipts#DelvAgreeSearch#DEFAULT#true#Click"],
    }, 
    btnDelSettleProfile:{
      DEFAULT:["WarehouseReceipts#DelvSettleSearch#DEFAULT#true#Click"],
    }, 
    btnClose: {
      DEFAULT: ["ContractManagement#MainMenu#DEFAULT#false#Click"],
    },
  };
  let _winServices = {};
  const [state, setState] = useState(states);
  const thisObj = {
    context: contextType,
    state: state,
    props: props,
    _buttonServices: _buttonServices,
    _buttonNavigation: _buttonNavigation,
    _winServices: _winServices,
    setState: setState,
  };
  useEffect(() => {
    parentWindow(thisObj);
  });
  useEffect(() => {
    callOnOpenPreSubmit(thisObj, state.windowName);
    callOnOpenService(thisObj, screenRef);
    // START_USER_CODE-USER_COMPONENTDIDMOUNT-METHODS

    // END_USER_CODE-USER_COMPONENTDIDMOUNT-METHODS
  }, []);

  // START_USER_CODE-USER_METHODS

  // END_USER_CODE-USER_METHODS
  initForm(thisObj);
  let validationSchema = object(_kaledo.validationSchema);
  let initialValues = _kaledo.initialValues;
  return (
    <Formik validationSchema={validationSchema} initialValues={initialValues}>
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        setFieldValue,
      }) => {
        thisObj.setFieldValue = setFieldValue = setFieldValue;
        thisObj.values = values = values;
        thisObj.handleChange = handleChange = handleChange;
        thisObj.handleBlur = handleBlur = handleBlur;
        thisObj.isValid = isValid = isValid;
        thisObj.errors = errors = errors;
        return (
          <div
            className={
              _kaledo.guiModuleName + "-" + state.windowName + " col-lg-12" + " centerWidth"
            }
            data-testid={state.windowName}
            ref={screenRef}
          >
            <Modal
              show={state.showPopup}
              onHide={vlaues => {
                handleModalHide(thisObj, values);
              }}
              data={dataCopyObj.dataToCopy}
              component={state.popupComponent}
            />
            {/* START_USER_CODE-USER_BEFORE_PAGE_HEADER*/}
            <ContractManagement_header headerData={state.headerData} />
            {/* END_USER_CODE-USER_BEFORE_PAGE_HEADER*/}
            <h1 className="pageHeader">{state.Label}</h1>
            {/* START_USER_CODE-USER_AFTER_PAGE_HEADER*/}

            {/* END_USER_CODE-USER_AFTER_PAGE_HEADER*/}

            <Form noValidate className="row">
              {/* START_USER_CODE-USER_BEFORE_Delivery*/}

              {/* END_USER_CODE-USER_BEFORE_Delivery*/}

              {/* START_USER_CODE-USER_BEFORE_grpbxDeliveryMenu*/}

              {/* END_USER_CODE-USER_BEFORE_grpbxDeliveryMenu*/}

              <GroupBoxWidget conf={state.grpbxDeliveryMenu} screenConf={state}>
                {/* START_USER_CODE-USER_BEFORE_btnDelAgreeProfile*/}

                {/* END_USER_CODE-USER_BEFORE_btnDelAgreeProfile*/}

                <ButtonWidget
                  conf={state.btnDelAgreeProfile}
                  screenConf={state}
                  onClick={event =>
                    invokeEventHandler(event, handleChange, handleBlur, thisObj)
                  }
                ></ButtonWidget>
                {/* START_USER_CODE-USER_AFTER_btnDelAgreeProfile*/}

                {/* END_USER_CODE-USER_AFTER_btnDelAgreeProfile*/}
                {/* START_USER_CODE-USER_BEFORE_btnDelSettleProfile*/}

                {/* END_USER_CODE-USER_BEFORE_btnDelSettleProfile*/}

                <ButtonWidget
                  conf={state.btnDelSettleProfile}
                  screenConf={state}
                  onClick={event =>
                    invokeEventHandler(event, handleChange, handleBlur, thisObj)
                  }
                ></ButtonWidget>
                {/* START_USER_CODE-USER_AFTER_btnDelSettleProfile*/}

                {/* END_USER_CODE-USER_AFTER_btnDelSettleProfile*/}
              </GroupBoxWidget>
              {/* START_USER_CODE-USER_AFTER_grpbxDeliveryMenu*/}

              {/* END_USER_CODE-USER_AFTER_grpbxDeliveryMenu*/}
              {/* START_USER_CODE-USER_BEFORE_cmmndCntnrClose*/}

              {/* END_USER_CODE-USER_BEFORE_cmmndCntnrClose*/}
              <img
                src={StripPic}
                  className="stripDesign"
                />
              <CommandContainerWidget
                conf={state.cmmndCntnrClose}
                screenConf={state}
              >
                {/* START_USER_CODE-USER_BEFORE_btnClose*/}

                {/* END_USER_CODE-USER_BEFORE_btnClose*/}

                <ButtonWidget
                  conf={state.btnClose}
                  screenConf={state}
                  onClick={event =>
                    invokeEventHandler(event, handleChange, handleBlur, thisObj)
                  }
                ></ButtonWidget>
                {/* START_USER_CODE-USER_AFTER_btnClose*/}

                {/* END_USER_CODE-USER_AFTER_btnClose*/}
              </CommandContainerWidget>
              {/* START_USER_CODE-USER_AFTER_cmmndCntnrClose*/}

              {/* END_USER_CODE-USER_AFTER_cmmndCntnrClose*/}

              {/* START_USER_CODE-USER_AFTER_Delivery*/}

              {/* END_USER_CODE-USER_AFTER_Delivery*/}
            </Form>
          </div>
        );
      }}
    </Formik>
  );
}
export default withRouter(WarehouseReceipts_Delivery);
